/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
// import { Tab, Nav } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import { showModal, getTrainings } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import PotentialTrainings from "components/widgets/training/PotentialTrainings";

class PotentialTrainingsContainer extends Component {
  state = {
    dataFetched: false,
  };
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
  }

  fetchData = () => {
    this.props.getTrainings(
      "potential",
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    this.setState({
      dataFetched: true,
    });
  };

  renderTabbedContent = () => {
    if (!this.state.dataFetched) {
      return null;
    }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <PotentialTrainings data={this.props.data} />
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Bayi Eğitim Potansiyeli">10406</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Bayi Eğitim Potansiyeli">10406</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    data: state.trainings.data,
  };
};

export default connect(mapStateToProps, {
  showModal,
  getTrainings,
})(requireAuth(containsLongRunningProcess(PotentialTrainingsContainer)));
